import { hubbleAPI } from './url'
const resource = hubbleAPI + 'public/ct'

export default ($axios) => ({
  getCategories () {
    return $axios.get(`${resource}/categories`)
  },

  getCategory (id) {
    return $axios.get(`${resource}/category/${id}`)
  },

  getRootCategories () {
    return $axios.get(`${resource}/categories/root`)
  },

  getCategoryTree (categoryId) {
    return $axios.get(`${resource}/category-tree/${categoryId}`)
  },

  create (payload) {
    return $axios.post(`${resource}`, payload)
  },

  update (id, payload) {
    return $axios.post(`${resource}/${id}`, payload)
  },

  delete (id) {
    return $axios.delete(`${resource}/category/${id}`)
  }
})
